import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-pet-rehome-modal',
  templateUrl: './pet-rehome-modal.component.html',
  styleUrls: ['./pet-rehome-modal.component.scss'],
})
export class PetRehomeModalComponent implements OnInit {
  @Input() petName: string;

  public companyPhoneNumber: string;

  constructor(
    public activeModal: NgbActiveModal,
    private configService: ConfigService,
  ) {
    this.companyPhoneNumber = this.configService.getTextFromKey('company-phone-number');
  }
 
  ngOnInit(): void {}

}
